"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cepagatti": {
    "dc5041c6": [{
      "hkey": "7fd133f9",
      "slug": "buccieri-calcasacco",
      "name": "Buccieri-Calcasacco",
      "primary": true,
      "skipSearch": false
    }],
    "buccieri": [{
      "hkey": "7fd133f9",
      "slug": "buccieri-calcasacco",
      "name": "Buccieri-Calcasacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9efa4a0a": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "skipSearch": false
    }],
    "canto": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08709ca2": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "skipSearch": false
    }],
    "ciarra": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "090b5e84": [{
      "hkey": "5de12be7",
      "slug": "faiolo",
      "name": "Faiolo",
      "primary": true,
      "skipSearch": false
    }],
    "faiolo-aurora": [{
      "hkey": "5de12be7",
      "slug": "faiolo",
      "name": "Faiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2c49ff0d": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "skipSearch": false
    }],
    "farese": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "98f3fc16": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "skipSearch": false
    }],
    "fratini": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e47ed81": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "skipSearch": false
    }],
    "giansante": [{
      "hkey": "643bacbd",
      "slug": "cepagatti",
      "name": "Cepagatti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e4ebaea": [{
      "hkey": "db2873f9",
      "slug": "moncocitto",
      "name": "Moncocitto",
      "primary": true,
      "skipSearch": false
    }],
    "mongoccitto": [{
      "hkey": "db2873f9",
      "slug": "moncocitto",
      "name": "Moncocitto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "32182110": [{
      "hkey": "ec7324b7",
      "slug": "rapattoni-superiore",
      "name": "Rapattoni Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "quattroventi": [{
      "hkey": "ec7324b7",
      "slug": "rapattoni-superiore",
      "name": "Rapattoni Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a40dcc35": [{
      "hkey": "b33d23bc",
      "slug": "rapattoni-inferiore",
      "name": "Rapattoni Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "rapattoni-vecchio-ventignano": [{
      "hkey": "b33d23bc",
      "slug": "rapattoni-inferiore",
      "name": "Rapattoni Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;